import axios from 'axios';

// export const baseURL = `http://localhost:5050/`;
// export const baseURL = `http://zapadsib-docker.btk.modem.by:5050/`;
// export const baseURL = location.protocol + "//" + location.host + location.pathname ;

export const baseURL = `https://support.innerica.ru/`;

export const axiosInstance = axios.create({
  baseURL: baseURL + 'api',
  // baseURL: `/api`, //если в package.json вставлять "proxy": "http://localhost:5050", 
});
